import { userUpdated } from '../../users/usersSlice';
import { currentUserUpdated } from '../currentUserSlice';

export const updateCurrentChatUser =
  ({ user }) =>
  async (dispatch) => {
    dispatch(userUpdated({ user }));
    dispatch(currentUserUpdated({ user }));
  };
